import angular from 'angular'
import controller from './crew.controller'
import template from './crew.html'

import mainMenu from '../../shared/menu/menu.html'
import menu from './menu.html'

export default angular.module('crews', ['ui.router'])
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.crews', {
      url: '/crews',
      resolve: {
        crews: (Crews) => {
          'ngInject'

          return Crews.getCrews()
        },
        workforce: (Users) => {
          'ngInject'
          return Users.getWorkforce(true)
        }
      },
      views: {
        content: {
          controller,
          controllerAs: 'cr',
          template
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
  })
